import React from 'react';

import { ISvgIconProps } from '~/src/dash/components/icons/common';

export const BracketIcon = (props: ISvgIconProps) => {
  return (
    <svg
      width='12'
      height='9'
      viewBox='0 0 12 9'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={props.style}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M8.97069 0.523997L11.8674 4.12386C12.0468 4.34645 12.0438 4.66444 11.8608 4.88463L8.8609 8.48449C8.7421 8.62668 8.57171 8.69988 8.39952 8.69988C8.26392 8.69988 8.12833 8.65428 8.01553 8.56128C7.76114 8.34889 7.72694 7.97031 7.93873 7.71532L10.6248 4.49344L8.03533 1.27637C7.82834 1.01778 7.86854 0.640392 8.12713 0.4328C8.38512 0.224008 8.7625 0.266007 8.97069 0.523997ZM3.1391 0.515786C3.35089 0.261396 3.72828 0.227198 3.98447 0.438989C4.23886 0.651381 4.27306 1.02937 4.06127 1.28436L1.37517 4.50623L3.96467 7.72391C4.17166 7.98189 4.13146 8.35928 3.87287 8.56747C3.76248 8.65627 3.62928 8.70007 3.49729 8.70007C3.32209 8.70007 3.1481 8.62327 3.02931 8.47628L0.132619 4.87642C-0.0467743 4.65322 -0.0437745 4.33524 0.139218 4.11565L3.1391 0.515786Z'
        fill={props.color}
      />
    </svg>
  );
};

export const CalendarIcon = (props: ISvgIconProps) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='20'
      height='21'
      viewBox='0 0 20 21'
      fill='none'
      style={props.style}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M4.44441 14.4644C4.44441 13.8961 4.94441 13.4312 5.55552 13.4312C6.16663 13.4312 6.66663 13.8961 6.66663 14.4644C6.66663 15.0326 6.16663 15.4976 5.55552 15.4976C4.94441 15.4976 4.44441 15.0326 4.44441 14.4644ZM9.99999 13.4313H14.4444C15.0555 13.4313 15.5555 13.8962 15.5555 14.4645C15.5555 15.0327 15.0555 15.4976 14.4444 15.4976H9.99999C9.38888 15.4976 8.88888 15.0327 8.88888 14.4645C8.88888 13.8962 9.38888 13.4313 9.99999 13.4313ZM16.6661 18.5964H3.33279C2.72057 18.5964 2.22168 18.1325 2.22168 17.5633V11.3643H17.7772V17.5633C17.7772 18.1325 17.2783 18.5964 16.6661 18.5964ZM3.33279 4.13232H4.4439V5.16549C4.4439 5.73374 4.9439 6.19866 5.55501 6.19866C6.16612 6.19866 6.66612 5.73374 6.66612 5.16549V4.13232H13.3328V5.16549C13.3328 5.73374 13.8328 6.19866 14.4439 6.19866C15.055 6.19866 15.555 5.73374 15.555 5.16549V4.13232H16.6661C17.2783 4.13232 17.7772 4.59622 17.7772 5.16549V9.29817H2.22168V5.16549C2.22168 4.59622 2.72057 4.13232 3.33279 4.13232ZM16.6667 2.06634H15.5556V1.03317C15.5556 0.464926 15.0556 0 14.4444 0C13.8333 0 13.3333 0.464926 13.3333 1.03317V2.06634H6.66667V1.03317C6.66667 0.464926 6.16667 0 5.55556 0C4.94444 0 4.44444 0.464926 4.44444 1.03317V2.06634H3.33333C1.49556 2.06634 0 3.45698 0 5.16584V17.5639C0 19.2727 1.49556 20.6634 3.33333 20.6634H16.6667C18.5044 20.6634 20 19.2727 20 17.5639V5.16584C20 3.45698 18.5044 2.06634 16.6667 2.06634Z'
        fill={props.color}
      />
    </svg>
  );
};

export const ClockIcon = (props: ISvgIconProps) => {
  return (
    <svg
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={props.style}
    >
      <path
        d='M10 0C4.489 0 0 4.489 0 10C0 15.511 4.489 20 10 20C15.511 20 20 15.511 20 10C20 4.489 15.511 0 10 0ZM10 2C14.4301 2 18 5.56988 18 10C18 14.4301 14.4301 18 10 18C5.56988 18 2 14.4301 2 10C2 5.56988 5.56988 2 10 2ZM9 4V10.4141L13.293 14.707L14.707 13.293L11 9.58594V4H9Z'
        fill={props.color}
      />
    </svg>
  );
};

export const ScheduleClockIcon = (props: ISvgIconProps) => {
  return (
    <svg
      width='19'
      height='17'
      viewBox='0 0 19 17'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={props.style}
    >
      <path
        d='M11.2186 0.496394C9.81059 0.290359 8.37313 0.463692 7.05438 0.998531C5.73581 1.53327 4.58361 2.41008 3.7168 3.53859C2.85002 4.6671 2.29999 6.00645 2.12341 7.41848L2.12386 7.41915L0.352462 7.1601C0.228014 7.14191 0.105017 7.20117 0.0417338 7.30989C-0.0214377 7.4186 -0.0122859 7.55487 0.0650608 7.6541L2.48972 10.7645C2.59262 10.8966 2.78224 10.9221 2.91653 10.8221L6.00753 8.51856C6.10743 8.44411 6.15263 8.31687 6.12205 8.19623C6.09147 8.07546 5.99124 7.98506 5.86802 7.96698L4.10154 7.7086C4.10522 7.6529 4.11326 7.59788 4.12129 7.54274H4.1214C4.31036 6.25362 4.91364 5.06105 5.84023 4.14515C6.76681 3.22925 7.96632 2.63963 9.25753 2.46562C10.5488 2.2915 11.8616 2.54241 12.9977 3.1804C14.1338 3.81838 15.0314 4.8087 15.5548 6.00173C16.0784 7.19487 16.1994 8.52596 15.8996 9.7939C15.5999 11.0619 14.8956 12.1979 13.8933 13.0303C12.8909 13.8627 11.6448 14.3464 10.3434 14.408C9.04186 14.4697 7.75577 14.1062 6.67921 13.3723C6.50833 13.2567 6.30553 13.1973 6.09927 13.2024C5.89301 13.2077 5.69356 13.2771 5.52858 13.4011C5.26931 13.5953 5.12008 13.9029 5.12799 14.2267C5.13581 14.5505 5.29999 14.8504 5.56841 15.0317C6.8995 15.9351 8.47198 16.4161 10.0806 16.4121C11.6893 16.4081 13.2593 15.9191 14.586 15.0091C15.9125 14.099 16.9339 12.8102 17.5167 11.3109C18.0995 9.81152 18.2168 8.17136 17.8532 6.60415C17.4895 5.03693 16.662 3.6163 15.4784 2.52653C14.2948 1.43708 12.8102 0.729677 11.2185 0.496866L11.2186 0.496394Z'
        fill={props.color}
      />
      <path
        d='M10.5817 4.15015H10.5816C10.3255 4.15015 10.08 4.25183 9.89894 4.43298C9.71791 4.61401 9.61623 4.85957 9.61623 5.11561V8.19661L7.12483 10.0259C6.8468 10.2301 6.69881 10.567 6.73653 10.9099C6.77436 11.2527 6.99223 11.5493 7.30798 11.6881C7.62385 11.8267 7.98958 11.7864 8.26763 11.5822L11.5338 9.18402H11.5472L11.5471 5.11555C11.5472 4.85951 11.4454 4.61395 11.2643 4.43292C11.0833 4.25177 10.8378 4.15009 10.5817 4.15009L10.5817 4.15015Z'
        fill={props.color}
      />
    </svg>
  );
};

export const LogoutIcon = (props: ISvgIconProps) => {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={props.style}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M4.98554 8.72234C4.03438 8.72234 4.03438 7.27745 4.98554 7.27745H13.5336L12.0084 5.75222C11.3358 5.07965 12.3575 4.05817 13.0299 4.73074L15.7884 7.48926C16.0705 7.77139 16.0705 8.22882 15.7884 8.51095L13.0299 11.2695C12.3573 11.942 11.3358 10.9204 12.0084 10.2478L13.5338 8.72234H4.98554ZM10.4596 3.20321V1.72139C10.4596 0.773154 9.68664 0 8.7382 0H1.72139C0.772945 0 0 0.773154 0 1.72139V14.2786C0 14.75 0.193862 15.1803 0.506463 15.4935L0.505002 15.495C0.816559 15.8066 1.24706 16 1.72139 16H8.7382C9.68685 16 10.4596 15.2268 10.4596 14.2786V12.797C10.4596 11.8458 9.0147 11.8458 9.0147 12.797V14.2786C9.0147 14.4293 8.88887 14.5551 8.73799 14.5551H1.72139C1.64606 14.5551 1.57698 14.5238 1.52648 14.4733L1.52502 14.4748L1.44468 14.2786V1.7216C1.44468 1.57114 1.57093 1.4451 1.72139 1.4451H8.7382C8.88907 1.4451 9.01491 1.57114 9.01491 1.7216V3.20342C9.01491 4.15437 10.4596 4.15437 10.4596 3.20321Z'
        fill={props.color}
      />
    </svg>
  );
};

export const MobileFilterIcon = (props: ISvgIconProps) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='20'
      height='21'
      viewBox='0 0 20 21'
      fill='none'
      style={props.style}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M9.16699 16.1649C8.70699 16.1649 8.33366 15.7915 8.33366 15.3315C8.33366 14.8715 8.70699 14.4982 9.16699 14.4982C9.62699 14.4982 10.0003 14.8715 10.0003 15.3315C10.0003 15.7915 9.62699 16.1649 9.16699 16.1649ZM17.5003 14.4982H11.5128C11.1678 13.5307 10.252 12.8315 9.16699 12.8315C8.08199 12.8315 7.16616 13.5307 6.82116 14.4982H2.50033C2.03949 14.4982 1.66699 14.8707 1.66699 15.3315C1.66699 15.7924 2.03949 16.1649 2.50033 16.1649H6.82116C7.16616 17.1324 8.08199 17.8315 9.16699 17.8315C10.252 17.8315 11.1678 17.1324 11.5128 16.1649H17.5003C17.9612 16.1649 18.3337 15.7924 18.3337 15.3315C18.3337 14.8707 17.9612 14.4982 17.5003 14.4982ZM15.8337 11.1649C15.3737 11.1649 15.0003 10.7915 15.0003 10.3315C15.0003 9.87154 15.3737 9.49821 15.8337 9.49821C16.2937 9.49821 16.667 9.87154 16.667 10.3315C16.667 10.7915 16.2937 11.1649 15.8337 11.1649ZM15.8337 7.83154C14.7487 7.83154 13.8328 8.53071 13.4878 9.49821H2.50033C2.03949 9.49821 1.66699 9.87071 1.66699 10.3315C1.66699 10.7924 2.03949 11.1649 2.50033 11.1649H13.4878C13.8328 12.1324 14.7487 12.8315 15.8337 12.8315C17.212 12.8315 18.3337 11.7099 18.3337 10.3315C18.3337 8.95321 17.212 7.83154 15.8337 7.83154ZM5.83366 4.49821C6.29366 4.49821 6.66699 4.87154 6.66699 5.33154C6.66699 5.79154 6.29366 6.16488 5.83366 6.16488C5.37366 6.16488 5.00033 5.79154 5.00033 5.33154C5.00033 4.87154 5.37366 4.49821 5.83366 4.49821ZM2.50033 6.16488H3.48783C3.83283 7.13238 4.74866 7.83154 5.83366 7.83154C6.91866 7.83154 7.83449 7.13238 8.17949 6.16488H17.5003C17.9612 6.16488 18.3337 5.79238 18.3337 5.33154C18.3337 4.87071 17.9612 4.49821 17.5003 4.49821H8.17949C7.83449 3.53071 6.91866 2.83154 5.83366 2.83154C4.74866 2.83154 3.83283 3.53071 3.48783 4.49821H2.50033C2.03949 4.49821 1.66699 4.87071 1.66699 5.33154C1.66699 5.79238 2.03949 6.16488 2.50033 6.16488Z'
        fill={props.color}
      />
    </svg>
  );
};

export const ReturnIcon = (props: ISvgIconProps) => {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={props.style}
    >
      <path
        d='M10.0004 6.28573H5.37772L6.11483 5.54862C6.24085 5.40142 6.28371 5.20054 6.22874 5.0148C6.17389 4.82909 6.02861 4.6838 5.84291 4.62897C5.65719 4.574 5.45629 4.61686 5.30909 4.74288L3.59479 6.45717C3.48662 6.56444 3.42578 6.71049 3.42578 6.86292C3.42578 7.01522 3.48662 7.16126 3.59479 7.26867L5.30909 8.98296C5.45628 9.10885 5.65717 9.15184 5.84291 9.09686C6.02864 9.04189 6.17391 8.89661 6.22874 8.7109C6.28371 8.52519 6.24085 8.32429 6.11483 8.17722L5.37772 7.42861H10.0004C10.5108 7.42861 10.9825 7.70093 11.2376 8.1429C11.4928 8.58486 11.4928 9.12952 11.2376 9.57148C10.9825 10.0134 10.5108 10.2858 10.0004 10.2858H7.429C7.22479 10.2858 7.03615 10.3947 6.9341 10.5715C6.83206 10.7483 6.83206 10.9661 6.9341 11.1429C7.03615 11.3197 7.22479 11.4286 7.429 11.4286H10.0004C10.9191 11.4286 11.7681 10.9386 12.2274 10.1429C12.6867 9.34725 12.6867 8.36713 12.2274 7.57147C11.7681 6.77581 10.9191 6.28573 10.0004 6.28573Z'
        fill={props.color}
      />
      <path
        d='M8 6.52705e-05C5.87828 6.52705e-05 3.84356 0.84291 2.34314 2.34319C0.84288 3.84357 0 5.87855 0 8.00003C0 10.1215 0.842848 12.1565 2.34314 13.6569C3.84353 15.1571 5.87851 16 8 16C10.1215 16 12.1564 15.1572 13.6569 13.6569C15.1571 12.1565 16 10.1215 16 8.00003C16 6.59568 15.6304 5.21622 14.9282 4.00002C14.226 2.78382 13.2162 1.77398 12 1.07181C10.7838 0.369634 9.40429 0 7.99993 0L8 6.52705e-05ZM8 14.8573C6.18137 14.8573 4.4372 14.1348 3.15131 12.8488C1.86532 11.5629 1.14287 9.81872 1.14287 8.00016C1.14287 6.18161 1.86532 4.43737 3.15131 3.15149C4.43729 1.86551 6.18144 1.14306 8 1.14306C9.81856 1.14306 11.5628 1.86551 12.8487 3.15149C14.1347 4.43747 14.8571 6.18161 14.8571 8.00016C14.8571 9.81872 14.1347 11.563 12.8487 12.8488C11.5627 14.1348 9.81856 14.8573 8 14.8573Z'
        fill={props.color}
      />
    </svg>
  );
};

export const CheckboxCheckedIcon = (props: ISvgIconProps) => {
  return (
    <svg
      width='18'
      height='17'
      viewBox='0 0 18 17'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={props.style}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M10.9665 5.9461L8.28621 9.46581L7.1295 7.98823C6.88796 7.6794 6.44312 7.62556 6.135 7.8671C5.82687 8.10794 5.77233 8.55348 6.01387 8.8609L7.73583 11.0617C7.87041 11.2331 8.07583 11.333 8.294 11.333H8.29896C8.51783 11.3323 8.72466 11.2289 8.85712 11.0539L12.0935 6.8039C12.3308 6.49223 12.2706 6.04881 11.9589 5.81152C11.6472 5.57423 11.2024 5.63515 10.9665 5.9461ZM14.0091 12.75C14.0091 13.141 13.6911 13.4583 13.3008 13.4583H4.80078C4.41049 13.4583 4.09245 13.141 4.09245 12.75V4.25C4.09245 3.859 4.41049 3.54167 4.80078 3.54167H13.3008C13.6911 3.54167 14.0091 3.859 14.0091 4.25V12.75ZM13.3008 2.125H4.80078C3.6292 2.125 2.67578 3.07842 2.67578 4.25V12.75C2.67578 13.9216 3.6292 14.875 4.80078 14.875H13.3008C14.4724 14.875 15.4258 13.9216 15.4258 12.75V4.25C15.4258 3.07842 14.4724 2.125 13.3008 2.125Z'
        fill={props.color}
      />
    </svg>
  );
};

export const CheckboxUncheckedIcon = (props: ISvgIconProps) => {
  return (
    <svg
      width='18'
      height='17'
      viewBox='0 0 18 17'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={props.style}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M14.0091 12.75C14.0091 13.141 13.6911 13.4583 13.3008 13.4583H4.80078C4.41049 13.4583 4.09245 13.141 4.09245 12.75V4.25C4.09245 3.859 4.41049 3.54167 4.80078 3.54167H13.3008C13.6911 3.54167 14.0091 3.859 14.0091 4.25V12.75ZM13.3008 2.125H4.80078C3.6292 2.125 2.67578 3.07842 2.67578 4.25V12.75C2.67578 13.9216 3.6292 14.875 4.80078 14.875H13.3008C14.4724 14.875 15.4258 13.9216 15.4258 12.75V4.25C15.4258 3.07842 14.4724 2.125 13.3008 2.125V2.125Z'
        fill={props.color}
      />
    </svg>
  );
};

export const TrendMiniIcon = (props: ISvgIconProps) => {
  return (
    <svg
      width='15'
      height='15'
      viewBox='0 0 15 15'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={props.style}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12.7964 4.56175C12.7952 4.51975 12.783 4.48008 12.7719 4.43983C12.7632 4.406 12.7591 4.37158 12.7445 4.34067C12.7311 4.31033 12.7083 4.28583 12.6885 4.25783C12.664 4.22225 12.6418 4.18667 12.6103 4.1575C12.6051 4.15225 12.6027 4.14525 12.5969 4.14058C12.5759 4.1225 12.5502 4.11608 12.5275 4.1015C12.4925 4.07875 12.4581 4.05542 12.4184 4.04025C12.3793 4.02625 12.3408 4.02275 12.3006 4.01692C12.2726 4.01283 12.2475 4 12.2177 4H9.30107C8.97849 4 8.71774 4.26133 8.71774 4.58333C8.71774 4.90533 8.97849 5.16667 9.30107 5.16667H10.9496L8.59524 7.913L6.1009 6.41675C5.85415 6.26742 5.53682 6.32225 5.35249 6.54333L2.43582 10.0433C2.2299 10.2907 2.26315 10.6587 2.51049 10.8647C2.62015 10.9557 2.75199 11 2.88382 11C3.05124 11 3.2169 10.9288 3.3324 10.79L5.9294 7.67383L8.41732 9.16717C8.66174 9.31358 8.97557 9.26225 9.16049 9.04642L11.6344 6.16008V7.5C11.6344 7.822 11.8952 8.08333 12.2177 8.08333C12.5403 8.08333 12.8011 7.822 12.8011 7.5V4.58333C12.8011 4.57575 12.797 4.56933 12.7964 4.56175Z'
        fill={props.color}
      />
    </svg>
  );
};

export const CaretMiniDownIcon = (props: ISvgIconProps) => {
  return (
    <svg
      width='6'
      height='5'
      viewBox='0 0 6 5'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={props.style}
    >
      <path
        d='M5.295 0.795L3 3.085L0.705 0.795L0 1.5L3 4.5L6 1.5L5.295 0.795Z'
        fill={props.color}
      />
    </svg>
  );
};

export const CaretMiniUpIcon = (props: ISvgIconProps) => {
  return (
    <svg
      width='6'
      height='5'
      viewBox='0 0 6 5'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={props.style}
    >
      <path
        d='M0.705 4.205L3 1.915L5.295 4.205L6 3.5L3 0.5L0 3.5L0.705 4.205Z'
        fill={props.color}
      />
    </svg>
  );
};

export const VerticalBarIcon = (props: ISvgIconProps) => {
  return (
    <svg
      width='13'
      height='20'
      viewBox='0 0 13 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={props.style}
    >
      <rect x='4' y='3' width='5' height='14' rx='2' fill={props.color} />
    </svg>
  );
};

export const RefreshIcon = (props: ISvgIconProps) => {
  return (
    <svg
      width='11'
      height='11'
      viewBox='0 0 11 11'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={props.style}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M10.3942 6.33183C10.0874 6.23442 9.75953 6.40417 9.66153 6.711C9.11495 8.4295 7.50612 9.58333 5.65811 9.58333C3.34695 9.58333 1.46745 7.75167 1.46745 5.5C1.46745 3.24892 3.34695 1.41667 5.65811 1.41667C6.66612 1.41667 7.61695 1.76783 8.3677 2.39083L7.1042 2.18258C6.78337 2.12425 6.48586 2.34533 6.43336 2.66267C6.38086 2.98058 6.59611 3.281 6.91403 3.33292L9.39087 3.74242C9.42295 3.74767 9.45562 3.75 9.48653 3.75C9.55595 3.75 9.62362 3.73775 9.68662 3.71442C9.7082 3.70625 9.7257 3.69108 9.7467 3.68C9.7852 3.66017 9.82545 3.64267 9.8587 3.61467C9.8797 3.59775 9.89312 3.57325 9.9112 3.55342C9.93862 3.52483 9.96778 3.49742 9.9882 3.46242C10.0028 3.43733 10.0086 3.40758 10.0197 3.37958C10.0337 3.34517 10.0524 3.31308 10.0594 3.27517L10.4992 0.941833C10.5587 0.625083 10.3504 0.319417 10.0337 0.2605C9.71811 0.203333 9.41187 0.40925 9.35237 0.725417L9.1937 1.566C8.22303 0.725417 6.97878 0.25 5.65811 0.25C2.70411 0.25 0.300781 2.60492 0.300781 5.5C0.300781 8.39508 2.70411 10.75 5.65811 10.75C8.01595 10.75 10.0716 9.26892 10.7734 7.0645C10.8708 6.75767 10.701 6.42983 10.3942 6.33183'
        fill={props.color}
      />
    </svg>
  );
};

export const BellIconSmall = (props: ISvgIconProps) => {
  return (
    <svg
      width='14'
      height='15'
      viewBox='0 0 14 15'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={props.style}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M3.21728 9.83397L3.90561 9.14447C4.12611 8.92397 4.24745 8.63113 4.24745 8.31963V5.59139C4.24745 4.7998 4.59161 4.04322 5.19245 3.51705C5.79795 2.98622 6.56911 2.75289 7.37236 2.85847C8.72978 3.03872 9.75353 4.26605 9.75353 5.71388V8.31963C9.75353 8.63113 9.87486 8.92397 10.0948 9.14389L10.7837 9.83397H3.21728ZM8.16686 11.1996C8.16686 11.724 7.63253 12.1673 7.0002 12.1673C6.36786 12.1673 5.83353 11.724 5.83353 11.1996V11.0006H8.16686V11.1996ZM11.9708 9.37197L10.9202 8.31963V5.71389C10.9202 3.6833 9.4607 1.95839 7.5252 1.7023C6.40403 1.55297 5.27236 1.89539 4.42361 2.63972C3.56961 3.38755 3.08078 4.46322 3.08078 5.59139L3.0802 8.31963L2.02961 9.37197C1.75603 9.64613 1.67495 10.0539 1.82311 10.4115C1.97186 10.7696 2.31778 11.0006 2.70511 11.0006H4.66686V11.1996C4.66686 12.3767 5.71336 13.334 7.0002 13.334C8.28703 13.334 9.33353 12.3767 9.33353 11.1996V11.0006H11.2953C11.6826 11.0006 12.0279 10.7696 12.1761 10.4121C12.3249 10.0539 12.2444 9.64555 11.9708 9.37197Z'
        fill={props.color}
      />
    </svg>
  );
};

export const GearIconSmall = (props: ISvgIconProps) => {
  return (
    <svg
      width='14'
      height='15'
      viewBox='0 0 14 15'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={props.style}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M6.63477 12.166H7.36452V11.7186C7.36452 11.1732 7.69993 10.6832 8.21852 10.4691C8.75518 10.2457 9.34143 10.3553 9.7276 10.7438L10.042 11.0594L10.56 10.5414L10.2421 10.2241C9.85535 9.83793 9.74627 9.25227 9.96385 8.73252C9.96385 8.73252 9.96443 8.73193 9.96443 8.73135L9.97085 8.71502C10.1832 8.19993 10.6738 7.86393 11.2192 7.86393H11.666V7.13477H11.2192C10.6738 7.13477 10.1832 6.79935 9.96968 6.28077C9.7451 5.7441 9.85535 5.15785 10.2438 4.7711L10.5594 4.45668L10.042 3.93927L9.7241 4.25718C9.33793 4.64335 8.75285 4.75243 8.2331 4.53543C7.70052 4.31552 7.36452 3.82552 7.36452 3.2801V2.83268H6.63477V3.2801C6.63477 3.82552 6.29935 4.31552 5.78077 4.5296C5.24468 4.75418 4.65843 4.64393 4.27168 4.25485L3.95727 3.93927L3.43927 4.45727L3.75718 4.7746C4.14335 5.16077 4.25302 5.74643 4.03543 6.26618C3.8161 6.79877 3.32552 7.13477 2.7801 7.13477H2.33268V7.86393H2.7801C3.32552 7.86393 3.8161 8.19935 4.0296 8.71793C4.25418 9.2546 4.14393 9.84085 3.75543 10.2276L3.43985 10.542L3.95727 11.0594L4.27518 10.7415C4.66135 10.3553 5.24643 10.2463 5.76618 10.4633C6.29877 10.6832 6.63477 11.1732 6.63477 11.7186V12.166ZM7.54943 13.3327H6.44577C5.90677 13.3327 5.4681 12.894 5.4681 12.355V11.7186C5.4681 11.6328 5.39985 11.5739 5.33568 11.5477C5.25168 11.5133 5.16185 11.5063 5.10002 11.5663L4.65085 12.0161C4.26818 12.3976 3.64635 12.3988 3.26427 12.0161L2.4826 11.2344C2.2971 11.0489 2.1956 10.8028 2.1956 10.5403C2.19618 10.2783 2.29827 10.0322 2.48435 9.84668L2.93235 9.40043C2.9936 9.33918 2.98718 9.24935 2.95977 9.1846C2.92477 9.09885 2.86643 9.0306 2.7801 9.0306H2.14777C1.60643 9.0306 1.16602 8.59077 1.16602 8.04943V6.94577C1.16602 6.40618 1.60468 5.9681 2.14427 5.9681H2.7801C2.86585 5.9681 2.92477 5.89927 2.95102 5.8351C2.98602 5.7511 2.99302 5.66068 2.93235 5.60002L2.4826 5.15085C2.1011 4.7676 2.1011 4.14577 2.4826 3.76427L3.26427 2.9826C3.44977 2.7971 3.69535 2.6956 3.95727 2.6956H3.95843C4.22035 2.6956 4.4671 2.79768 4.65202 2.98377L5.09827 3.43235C5.15952 3.49418 5.24993 3.48718 5.31468 3.45977C5.39985 3.42418 5.4681 3.36585 5.4681 3.2801V2.64777C5.4681 2.10643 5.90852 1.66602 6.44985 1.66602H7.55352C8.09252 1.66602 8.53118 2.10468 8.53118 2.64368V3.2801C8.53118 3.36585 8.59943 3.42477 8.6636 3.45102C8.74818 3.48602 8.83802 3.4936 8.89927 3.43235L9.34843 2.9826C9.7311 2.6011 10.3529 2.59993 10.735 2.9826L11.5173 3.76485C11.7028 3.94977 11.8043 4.19593 11.8037 4.45843C11.8037 4.71977 11.7016 4.96652 11.5155 5.15143L11.0669 5.59827C11.0057 5.65952 11.0121 5.74935 11.0395 5.8141C11.0745 5.89985 11.1328 5.9681 11.2192 5.9681H11.8515C12.3928 5.9681 12.8327 6.40793 12.8327 6.94927V8.05293C12.8327 8.59252 12.3946 9.0306 11.855 9.0306H11.2192C11.1334 9.0306 11.0745 9.09943 11.0483 9.1636C11.0477 9.16418 11.0407 9.18168 11.0401 9.18285C11.0133 9.2476 11.0063 9.33802 11.0669 9.39868L11.5167 9.84785C11.8982 10.2311 11.8982 10.8529 11.5167 11.2344L10.735 12.0161C10.5495 12.2016 10.3039 12.3031 10.042 12.3031H10.0408C9.77893 12.3031 9.53218 12.201 9.34727 12.0149L8.90102 11.5663C8.83977 11.5051 8.74877 11.5121 8.6846 11.5389C8.59943 11.5745 8.53118 11.6328 8.53118 11.7186V12.3509C8.53118 12.8923 8.09077 13.3327 7.54943 13.3327ZM6.99964 6.62435C6.51722 6.62435 6.12464 7.01693 6.12464 7.49935C6.12464 7.98177 6.51722 8.37435 6.99964 8.37435C7.48206 8.37435 7.87464 7.98177 7.87464 7.49935C7.87464 7.01693 7.48206 6.62435 6.99964 6.62435ZM6.99964 9.54102C5.87381 9.54102 4.95797 8.62518 4.95797 7.49935C4.95797 6.37352 5.87381 5.45768 6.99964 5.45768C8.12547 5.45768 9.04131 6.37352 9.04131 7.49935C9.04131 8.62518 8.12547 9.54102 6.99964 9.54102Z'
        fill={props.color}
      />
    </svg>
  );
};

export const CaretDownIcon = (props: ISvgIconProps) => {
  return (
    <svg
      width='14'
      height='10'
      viewBox='0 0 14 10'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={props.style}
    >
      <path
        d='M12.355 0.521504L7 5.86484L1.645 0.521504L0 2.1665L7 9.1665L14 2.1665L12.355 0.521504Z'
        fill={props.color}
      />
    </svg>
  );
};

export const RefreshCycleIcon = (props: ISvgIconProps) => {
  return (
    <svg
      width='13'
      height='13'
      viewBox='0 0 13 13'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={props.style}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M11.3922 5.66303C11.3885 5.67097 11.3849 5.67892 11.3815 5.687C11.3781 5.69538 11.3754 5.70411 11.3727 5.71283C11.3683 5.727 11.364 5.74111 11.3565 5.7535C11.3417 5.77801 11.3224 5.79859 11.303 5.81923C11.2975 5.82512 11.292 5.83101 11.2865 5.837C11.2805 5.84326 11.2751 5.85013 11.2698 5.85699C11.2623 5.86657 11.2549 5.87613 11.2455 5.884C11.2175 5.90687 11.1852 5.92277 11.1529 5.93861C11.1506 5.93974 11.1483 5.94087 11.146 5.942C11.1392 5.94531 11.1327 5.94946 11.1262 5.95363C11.117 5.95955 11.1078 5.96548 11.0975 5.969C11.0435 5.989 10.986 6 10.9265 6C10.8995 6 10.8715 5.998 10.844 5.993L8.71903 5.6405C8.44653 5.5955 8.26253 5.338 8.30753 5.0655C8.35253 4.7935 8.60953 4.607 8.88253 4.6545L9.70453 4.7905C9.08203 3.6975 7.89353 3 6.58553 3C5.10603 3 3.80253 3.859 3.26403 5.1875C3.18553 5.3825 2.99803 5.5 2.80053 5.5C2.73803 5.5 2.67453 5.4885 2.61303 5.4635C2.35703 5.36 2.23353 5.0685 2.33753 4.8125C3.02953 3.104 4.69703 2 6.58553 2C8.29153 2 9.84203 2.935 10.6245 4.394L10.809 3.4075C10.86 3.1365 11.122 2.957 11.3925 3.009C11.664 3.0595 11.843 3.321 11.792 3.5925L11.4175 5.5925C11.4127 5.61801 11.4025 5.6405 11.3922 5.66303ZM9.83748 7.8126C9.94098 7.5561 10.233 7.4331 10.4885 7.5366C10.7445 7.6401 10.868 7.9316 10.764 8.1876C10.072 9.8961 8.40448 11.0001 6.51598 11.0001C4.80998 11.0001 3.25948 10.0651 2.47698 8.6061L2.29198 9.5921C2.24748 9.8326 2.03748 10.0001 1.80098 10.0001C1.77048 10.0001 1.73948 9.9971 1.70848 9.9911C1.43698 9.9406 1.25848 9.6791 1.30948 9.4076L1.68398 7.4076C1.68778 7.38796 1.6962 7.37053 1.70465 7.35302C1.70954 7.34289 1.71445 7.33273 1.71848 7.3221C1.72243 7.31214 1.72588 7.30183 1.72934 7.2915C1.73682 7.26916 1.74433 7.24675 1.75698 7.2276C1.76436 7.21622 1.77401 7.20712 1.78371 7.19795C1.78979 7.19221 1.7959 7.18645 1.80148 7.1801C1.80588 7.175 1.81024 7.16987 1.81459 7.16474C1.83838 7.13669 1.86196 7.10889 1.89198 7.0886C1.89493 7.08646 1.89845 7.08517 1.90193 7.08391C1.90494 7.08281 1.90793 7.08172 1.91048 7.0801C1.95898 7.0486 2.01098 7.0241 2.06848 7.0116C2.07198 7.01079 2.07563 7.011 2.07926 7.01121C2.08238 7.01138 2.08548 7.01156 2.08848 7.0111C2.14348 7.0021 2.19898 6.9966 2.25748 7.0066L4.38248 7.3596C4.65498 7.4041 4.83898 7.6621 4.79398 7.9346C4.75348 8.1791 4.54148 8.3526 4.30098 8.3526C4.27398 8.3526 4.24648 8.3506 4.21898 8.3456L3.39698 8.2096C4.01948 9.3026 5.20798 10.0001 6.51598 10.0001C7.99548 10.0001 9.29898 9.1411 9.83748 7.8126Z'
        fill={props.color}
      />
    </svg>
  );
};

export const PauseIcon = (props: ISvgIconProps) => {
  return (
    <svg
      width='12'
      height='12'
      viewBox='0 0 12 12'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={props.style}
    >
      <path
        d='M3.9 12C4.38857 12 4.8 11.6525 4.8 11.1892V0.810811C4.8 0.370656 4.41429 0 3.9 0C3.38571 0 3 0.34749 3 0.810811V11.1892C3 11.6525 3.38571 12 3.9 12Z'
        fill={props.color}
      />
      <path
        d='M7.69999 12C8.18856 12 8.59999 11.6525 8.59999 11.1892V0.810811C8.59999 0.370656 8.21427 0 7.69999 0C7.21142 0 6.79999 0.34749 6.79999 0.810811V11.1892C6.8257 11.6525 7.21142 12 7.69999 12Z'
        fill={props.color}
      />
    </svg>
  );
};

export const NoticeIcon = (props: ISvgIconProps) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='18'
      height='19'
      viewBox='0 0 19 19'
      style={props.style}
    >
      <path
        id='Path_457'
        data-name='Path 457'
        d='M17,4H14a2,2,0,1,0-4,0H7A3,3,0,0,0,4,7V17a3,3,0,0,0,3,3H17a3,3,0,0,0,3-3V7a3,3,0,0,0-3-3Zm2,13a2,2,0,0,1-2,2H7a2,2,0,0,1-2-2V7A2,2,0,0,1,7,5H8A1,1,0,0,0,9,6h6a1,1,0,0,0,1-1h1a2,2,0,0,1,2,2Zm-6-7v3a1,1,0,0,1-2,0V10a1,1,0,0,1,2,0Zm0,6a1,1,0,1,1-1-1A1,1,0,0,1,13,16Z'
        transform='translate(-4 -2)'
        fill={props.color}
      />
    </svg>
  );
};

export const QuickFilterIcon = (props: ISvgIconProps) => {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={props.style}
    >
      <path
        d='M14 4.23031C14 4.4682 13.9079 4.69635 13.744 4.86456C13.5801 5.03278 13.3578 5.12728 13.126 5.12728H2.87396C2.64217 5.12728 2.41988 5.03278 2.25598 4.86456C2.09208 4.69635 2 4.4682 2 4.23031C2 3.99242 2.09208 3.76427 2.25598 3.59606C2.41988 3.42785 2.64217 3.33334 2.87396 3.33334H13.126C13.3578 3.33334 13.5801 3.42785 13.744 3.59606C13.9079 3.76427 14 3.99242 14 4.23031V4.23031Z'
        fill={props.color}
      />
      <path
        d='M12.5483 8.00073C12.5483 8.11852 12.5257 8.23516 12.4818 8.34398C12.4379 8.45281 12.3735 8.55169 12.2924 8.63498C12.2112 8.71827 12.1149 8.78434 12.0088 8.82942C11.9028 8.8745 11.7891 8.8977 11.6744 8.8977H4.32562C4.21085 8.8977 4.0972 8.8745 3.99117 8.82942C3.88514 8.78434 3.78879 8.71827 3.70764 8.63498C3.62648 8.55169 3.56211 8.45281 3.51819 8.34398C3.47427 8.23516 3.45166 8.11852 3.45166 8.00073V8.00073C3.45166 7.88294 3.47427 7.7663 3.51819 7.65747C3.56211 7.54865 3.62648 7.44977 3.70764 7.36648C3.78879 7.28318 3.88514 7.21711 3.99117 7.17204C4.0972 7.12696 4.21085 7.10376 4.32562 7.10376H11.6744C11.9062 7.10376 12.1285 7.19826 12.2924 7.36648C12.4563 7.53469 12.5483 7.76284 12.5483 8.00073V8.00073Z'
        fill={props.color}
      />
      <path
        d='M10.3707 11.7697C10.3707 11.8875 10.3481 12.0041 10.3042 12.1129C10.2602 12.2218 10.1959 12.3206 10.1147 12.4039C10.0336 12.4872 9.93721 12.5533 9.83117 12.5984C9.72514 12.6434 9.61149 12.6666 9.49672 12.6666H6.50287C6.27108 12.6666 6.04878 12.5721 5.88488 12.4039C5.72098 12.2357 5.62891 12.0076 5.62891 11.7697V11.7697C5.62891 11.5318 5.72098 11.3036 5.88488 11.1354C6.04878 10.9672 6.27108 10.8727 6.50287 10.8727H9.49693C9.72868 10.8728 9.95092 10.9673 10.1148 11.1355C10.2786 11.3037 10.3707 11.5318 10.3707 11.7697V11.7697Z'
        fill={props.color}
      />
    </svg>
  );
};

export const DownloadIcon = (props: ISvgIconProps) => {
  return (
    <svg
      width='15'
      height='16'
      viewBox='0 0 15 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={props.style}
    >
      <path
        d='M6.98098 10.9255C7.0302 10.9924 7.0933 11.0465 7.16545 11.0837C7.2376 11.121 7.31688 11.1403 7.39723 11.1403C7.47758 11.1403 7.55687 11.121 7.62902 11.0837C7.70117 11.0465 7.76427 10.9924 7.81349 10.9255L11.1277 6.33969C11.1856 6.25827 11.2208 6.16149 11.2295 6.06018C11.2381 5.95887 11.2198 5.85704 11.1766 5.76606C11.1334 5.67509 11.067 5.59856 10.9849 5.54505C10.9027 5.49154 10.808 5.46315 10.7114 5.46306L8.91833 5.46306V0.455333C8.91857 0.395466 8.90755 0.33614 8.88591 0.280781C8.86426 0.225422 8.83242 0.175126 8.79222 0.132794C8.75202 0.090461 8.70425 0.0569318 8.65168 0.0341394C8.5991 0.0113469 8.54277 -0.00025715 8.48591 -2.2132e-06H6.30856C6.25173 -0.000214654 6.19542 0.0114185 6.14289 0.03423C6.09035 0.0570415 6.04262 0.0905804 6.00245 0.132909C5.96228 0.175237 5.93046 0.225519 5.90884 0.280857C5.88721 0.336195 5.8762 0.395493 5.87644 0.455333V5.44604H4.08333C3.98673 5.44613 3.89207 5.47452 3.80992 5.52803C3.72777 5.58154 3.66139 5.65807 3.61819 5.74904C3.57499 5.84002 3.55668 5.94186 3.56532 6.04316C3.57395 6.14447 3.60918 6.24125 3.66707 6.32267L6.98098 10.9255Z'
        fill={props.color}
      />
      <path
        d='M0.432424 16H14.3778C14.4347 16.0003 14.491 15.9887 14.5436 15.9659C14.5962 15.9431 14.6439 15.9095 14.6841 15.8672C14.7243 15.8249 14.7562 15.7746 14.7778 15.7192C14.7995 15.6639 14.8105 15.6045 14.8102 15.5447V10.2004C14.8105 10.1406 14.7995 10.0812 14.7778 10.0259C14.7562 9.97051 14.7243 9.92022 14.6841 9.87788C14.6439 9.83555 14.5962 9.80202 14.5436 9.77923C14.491 9.75644 14.4347 9.74483 14.3778 9.74509H12.6164C12.5596 9.74483 12.5032 9.75644 12.4507 9.77923C12.3981 9.80202 12.3503 9.83555 12.3101 9.87788C12.2699 9.92022 12.2381 9.97051 12.2164 10.0259C12.1948 10.0812 12.1838 10.1406 12.184 10.2004V13.251H2.60855L2.60855 10.2004C2.6088 10.1406 2.59778 10.0812 2.57613 10.0259C2.55448 9.97051 2.52264 9.92022 2.48244 9.87788C2.44224 9.83555 2.39447 9.80202 2.3419 9.77923C2.28933 9.75644 2.23299 9.74483 2.17613 9.74509H0.432424C0.37557 9.74483 0.319231 9.75644 0.266658 9.77923C0.214085 9.80202 0.166319 9.83555 0.126117 9.87788C0.0859149 9.92022 0.0540722 9.97051 0.0324268 10.0259C0.0107814 10.0812 -0.000238203 10.1406 3.90444e-06 10.2004L3.90444e-06 15.5447C-0.000238203 15.6045 0.0107814 15.6639 0.0324268 15.7192C0.0540722 15.7746 0.0859149 15.8249 0.126117 15.8672C0.166319 15.9095 0.214085 15.9431 0.266658 15.9659C0.319231 15.9887 0.37557 16.0003 0.432424 16V16Z'
        fill={props.color}
      />
    </svg>
  );
};
